import type { FC, ReactNode } from "react";
import type { ButtonBasicProps } from "@/components/buttons/shared.ts";
import { styled } from "@linaria/react";

const ButtonEmptyStyle = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  border: none;
  cursor: pointer;

  transition: all 150ms
    linear(
      0,
      1.114 8.5%,
      1.37 12.9%,
      1.315 16.2%,
      0.941 24%,
      0.869 27.8%,
      0.882 30.7%,
      1.012 38.3%,
      1.046 42.7%,
      0.984,
      1.006 72.2%,
      1
    );

  &[data-flare="true"] {
    &:hover {
      scale: 110%;
    }

    &:active {
      scale: 90%;
    }
  }
`;

interface ButtonEmptyProps extends ButtonBasicProps {
  children?: ReactNode;
  flare?: boolean;
}

export const ButtonEmpty: FC<ButtonEmptyProps> = ({ onClick, children, tooltip, flare }) => {
  return (
    <ButtonEmptyStyle
      onClick={() => {
        if (onClick) {
          onClick(() => {});
        }
      }}
      data-flare={flare}
      data-tooltip={tooltip}
      data-direction={"top"}
    >
      {children}
    </ButtonEmptyStyle>
  );
};
